import { FormControl, FormField } from '@/components/ui/form';
import { FormDescription } from '@/components/ui/form';
import { FormItem } from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';
import { UseFormReturn, ControllerRenderProps } from 'react-hook-form';

export const ToggleWithDescription = ({
  form,
  name,
  children
}: {
  form: UseFormReturn<any>;
  name: string;
  children: React.ReactNode;
}) => {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }: { field: ControllerRenderProps<any, string> }) => (
        <FormItem>
          <div className="flex items-start gap-2">
            <FormControl>
              <Switch
                checked={field.value as boolean}
                onCheckedChange={(checked: boolean) => {
                  field.onChange(checked);
                }}
              />
            </FormControl>
            <div className="flex-1">
              <FormDescription>{children}</FormDescription>
            </div>
          </div>
        </FormItem>
      )}
    />
  );
};
